const apiUrl = process.env.REACT_APP_API_URL

export default async function postAssessment(
    skill: string,
    studentId: string,
    batchId: number,
    videoPath: string
) {
    const token = localStorage.getItem('token')
    const data = {
        skill: skill,
        studentId: parseInt(studentId),
        batchId: batchId,
        videoPath: videoPath,
    }

    const assessmentResponse = await fetch(`${apiUrl}/assessment`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })
    const { assessment_id } = await assessmentResponse.json()

    return assessment_id
}

export async function getAssessmentsByStudentId(studentId: string) {
    const token = localStorage.getItem('token')
    const res = await fetch(`${apiUrl}/assessment?studentId=${studentId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    const response: Assessment[] | null = await res.json()

    return response ?? []
}

export async function updateAssessmentDetailScore(assessment: Assessment) {
    const token = localStorage.getItem('token')
    const data = { detailScore: assessment.detailScore }
    const assessmentResponse = await fetch(
        `${apiUrl}/assessment?assessmentId=${assessment.id}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        }
    )
    const response = await assessmentResponse.json()

    return response
}

export interface Assessment {
    id: number
    skill: string
    timestamp: string
    videoPath: string
    result: string
    batch: string
    finalScore: number
    detailScore: DetailScore[]
}

interface DetailScore {
    label: string
    score: number
}
